const t = "_datePicker_1t0ov_1", o = "_collapsed_1t0ov_10", e = "_leftPanel_1t0ov_17", _ = "_footer_1t0ov_35", n = "_note_1t0ov_46", a = "_rightPanel_1t0ov_53", c = "_actions_1t0ov_63", l = {
  datePicker: t,
  collapsed: o,
  leftPanel: e,
  footer: _,
  note: n,
  rightPanel: a,
  actions: c
};
export {
  c as actions,
  o as collapsed,
  t as datePicker,
  l as default,
  _ as footer,
  e as leftPanel,
  n as note,
  a as rightPanel
};
//# sourceMappingURL=index.es5710.js.map
